import { RootState } from '@/store/types/RootState';

export const selectMyClaimsListPagination = (state: RootState) => state.claims.myClaimsListPagination;
export const selectMyClaimsListTabCounters = (state: RootState) => state.claims.myClaimsListTabCounters;
export const selectMyClaimsListDataRequestsStates = (state: RootState) => state.claims.dataRequestsStates;
export const selectMyClaimsListData = (state: RootState) => state.claims.myClaimsListData;

export const selectClaimCreationIsLoading = (state: RootState) => state.createClaim.isLoading;
export const selectClaimCreationIsError = (state: RootState) => state.createClaim.isError;
export const selectClaimCreationIsSuccess = (state: RootState) => state.createClaim.isSuccess;
export const selectLastCreatedClaimId = (state: RootState) => state.createClaim.lastCreatedClaimId;
